import React from "react";

const CareerOptionsYEE = () => {
  const data = [
    {
      description: "Business Consultant",
      icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/certificate-svgrepo-com.svg",
    },
    {
      description: "Entrepreneur/Startup Founder",
      icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/attend-class-svgrepo-com.svg",
    },
    {
      description: "Venture Capitalist/Investor",
      icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/mind-svgrepo-com.svg",
    },
    {
      description: "Innovation Manager",
      icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/score-svgrepo-com.svg",
    },
    {
      description: "Social Entrepreneur",
      icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/discover-svgrepo-com.svg",
    },
    {
      description: "Corporate Entrepreneur",
      icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/question-and-answer-svgrepo-com.svg",
    },
  ];

  return (
    <div className="" id="career-option">
      <div className="max-w-6xl mx-auto p-5 bg-gray-100 rounded-lg">
        <div className="mb-5 space-y-2">
          <h2 className="text-3xl font-bold text-gray-800 text-center">
            Career Options
          </h2>
          <div className="h-1 w-10 bg-sdorange mx-auto"></div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {data.map((career, index) => (
            <div
              key={index}
              className="flex flex-col space-y-2 justify-center items-center p-5 rounded-lg hover:shadow-lg transition-shadow bg-sdbodywhiteywhitebody"
            >
              <div className="w-12 h-12 flex items-center justify-center">
                <img
                  src={career.icon}
                  alt={career.description}
                  className="w-20 h-20"
                />
              </div>
              <div className="text-gray-700">
                <p className="font-semibold text-center px-5">
                  {career.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CareerOptionsYEE;
